import { NotifyHelper } from "../../../helpers/toast";
import { eTangNhaActionsObj } from "../../action-types/category/ITangNhaActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const tangNhaActions = {
    ...generateActions(eTangNhaActionsObj, "TANG_NHA"),
    ...generateActionForKey(eTangNhaActionsObj, "TANG_NHA", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eTangNhaActionsObj, "TANG_NHA", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eTangNhaActionsObj, "TANG_NHA", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eTangNhaActionsObj, "TANG_NHA", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};